import { createAsyncThunk, createSlice, nanoid } from '@reduxjs/toolkit';
import axios from '../axios';
import { ErrorUI } from '../components/UI/Modals/Modals';
import { checkFileType } from '../containers/ActivityList/ClassForm/CommonClassFunc';
import ApiURL from '../services/ApiURL';
import { audioDuration, CheckValue, formatBytes, getExtension, GetGymId, videoThumbnail } from '../services/CommonFunction';
import { mediaFile, staticVar } from '../services/Constants';
import { messageService, toasterSubscriber } from '../services/subscriberService';

const initialState = {
    media: [],
    status: staticVar.idle
};

export const createMedia =  createAsyncThunk(ApiURL._addMedia, async (data,{ dispatch, rejectWithValue }) => {
    try {
        const formData = new FormData();
        formData.append('gym_id', GetGymId());
        formData.append('media_name', data.name);
        formData.append('tags', JSON.stringify(data.tag));
        // formData.append('is_media_shared', data.shareMediaClip);
        formData.append('media_shared_type', data.shareMediaClip?'MY_GYM_LOCATIONS':'SELF');
        if(data.is_media_upload_from_panel_completed) {
            formData.append('is_media_upload_from_panel_completed', true);
        }
        if(data.duration_in_ms) {
            formData.append('duration_in_ms', data.duration_in_ms);
        }
        if(data.updated) {
            if(data.file) {
                formData.append('media_image', data.file);
            }
            formData.append('media_id', data.id);
        } else {
            if(data.type.toLowerCase() === staticVar.video) {
                const url = URL.createObjectURL(mediaFile[data.id]);
                const response = await videoThumbnail(url, 30);
                if(CheckValue(response)) {
                    formData.append('media_image', response.file);
                    formData.append('duration_in_ms', Math.round(response.duration));
                }
            } else if(data.type.toLowerCase() === staticVar.audio) {
                const url = URL.createObjectURL(mediaFile[data.id]);
                const response = await audioDuration(url);
                if(CheckValue(response)) {
                    formData.append('duration_in_ms', Math.round(response.duration));
                }
            }
            formData.append('media_type', data.type.toUpperCase());
            if(data.type === staticVar.image) {
                formData.append('media_image', mediaFile[data.id]);
            } else if(data.type === staticVar.video) {
                formData.append('video_file_extension', getExtension(mediaFile[data.id].name));
            } else if(data.type === staticVar.audio) {
                formData.append('audio_file_extension', getExtension(mediaFile[data.id].name));
            }
        }
        messageService.show = false;
        const response = await axios.post(ApiURL[data.updated?'_updateMedia':'_addMedia'], formData, { onUploadProgress: (progressEvent) => {
            if(data.type === 'image' && !data.updated) {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                dispatch(uploadMediaSlice.actions.updateProgress({progress:percentCompleted,data:data}));
            }
        }});
        return {id: data.id, data: response.data.data, updated: data.updated, firstTime: CheckValue(data.firstTime)?data.firstTime:false};
    } catch (err) {
        if (!err.response) {
            throw err
        }
        if(err.response.data.statusCode === 401) {
            ErrorUI(err.response.data);
        }
        return rejectWithValue({err: err.response.data,id: data.id,updated: data.updated})
    }
});

const uploadMediaSlice = createSlice({
    name: 'uploadMedia',
    initialState,
    reducers: {
        addMedia: {
            reducer(state,action) {
                let media = [...state.media];
                action.payload.forEach(element => {
                    media.push(element);
                });
                // const loadMedia = media.filter( el => el.status === staticVar.loading);
                // if(!loadMedia.length) {
                //     const idleMedia = media.filter( el => el.status === staticVar.idle);
                //     if(idleMedia.length) {
                //         idleMedia[0].status = staticVar.loading;
                //         createMedia(idleMedia[0]);
                //     }
                // }
                state.media = media;
            },
            prepare(data) {
                return {
                    payload: Object.values(data).filter(el => checkFileType(el,el.type.split('/')[0])).map((el) => {
                        const id = nanoid();
                        let duration_in_ms = 0;
                        const type = el.type.split('/')[0];
                        mediaFile[id] = el;    
                        const result = (el.name).lastIndexOf(".");
                        return {
                            name: (el.name).substr(0, (result > -1)?result:(el.name.length)),
                            type,
                            duration_in_ms,
                            id: id,
                            localId: id,
                            createOnServer: false,
                            startOnserver: false,
                            uploadStart: false,
                            uploadEnd: false,
                            updated: false,
                            tag: [],
                            shareMediaClip: true,
                            media_upload_is_inprogress: true,
                            status: staticVar.idle,
                            audio_url: null,
                            image_url_original: null,
                            image_url_thumb: null,
                            video_url: null,
                            progress: 0,
                            size: formatBytes(el.size) 
                        }
                    })
                }
            }
        },
        deleteMedia: {
            reducer(state,action) {
                const newItem = {...state.media.find(el => el.id === action.payload.id)};
                if(Object.keys(newItem).length) {
                    toasterSubscriber.sendToasterData({
                        showToaster: true,
                        showImage: true,
                        id: newItem.id,
                        type: 'delete',
                        image: '',
                        message: newItem.name+' deleted successfully'
                    });
                    state.media = state.media.filter(el => el.id !== action.payload.id);
                }
            }
        },
        updateMedia: {
            reducer(state,action) {
                const newItem = {...state.media.find(el => el.id === action.payload.id)};
                if(Object.keys(newItem).length) {
                    newItem.name = action.payload.name;
                    newItem.tag = action.payload.tag;
                    newItem.shareMediaClip = action.payload.shareMediaClip;
                    const index = state.media.findIndex(el => el.id === action.payload.id);
                    state.media[index] = newItem;
                    toasterSubscriber.sendToasterData({
                        showToaster: true,
                        showImage: true,
                        id: action.payload.id,
                        type: 'update',
                        image: '',
                        message: newItem.name+' updated successfully'
                    });
                }
            }
        },
        updateMediaStatus: {
            reducer(state,action) {
                const newItem = {...state.media.find(el => el.id === action.payload.id)};
                if(Object.keys(newItem).length) {
                    newItem.status = action.payload.status;
                    newItem.progress = 0;
                    const index = state.media.findIndex(el => el.id === action.payload.id);
                    state.media[index] = newItem;
                }
            }
        },
        updateMediaStatusAndData: {
            reducer(state,action) {
                const newItem = {...state.media.find(el => el.id === action.payload.id)};
                if(Object.keys(newItem).length) {
                    newItem.status = staticVar.process;
                    if(newItem.progress < 100) {
                        newItem.progress = 100;
                    }
                    const index = state.media.findIndex(el => el.id === action.payload.id);
                    state.media[index] = newItem;
                }
            }
        },
        updateStatus: {
            reducer(state,action) {
                state.status = action.payload.status;
            }
        },
        mediaUploadDataChange: {
            reducer(state,action) {
                const index = state.media.findIndex(el => el.id === action.payload.id);
                if(index > -1) {
                    state.media[index] = {
                        ...state.media[index],
                        ...action.payload.data
                    };
                    if(action.payload.data.uploadEnd) {
                        toasterSubscriber.sendToasterData({
                            showToaster: true,
                            showImage: true,
                            id: action.payload.id,
                            type: 'upload',
                            image: '',
                            message: state.media[index].name+' upload successfully'
                        });
                    }
                    // state.media[index].uploadEnd = true;
                }
            }
        },
        setError: {
            reducer(state,action) {
                ErrorUI(action.payload.err);
                const newItem = {...state.media.find(el => el.id === action.payload.id)};
                if(Object.keys(newItem).length) {
                    newItem.updated = false;
                    // newItem.uploadStart = false;
                    newItem.status = staticVar.error;
                    const index = state.media.findIndex(el => el.id === action.payload.id);
                    state.media[index] = newItem;
                }
                state.status = staticVar.idle;
            }
        },
        updateProgress: {
            reducer(state,action) {
                const index = state.media.findIndex(el => el.id === action.payload.data.id);
                if(index > -1) {
                    const newItem = state.media[index];
                    if(!state.media[index].uploadStart) {
                        newItem.uploadStart = true;
                    }
                    newItem.progress = action.payload.progress;
                    state.media[index] = newItem;
                }
            }
        },
        resetMedia: (state) => {
            state.media = []; 
            state.status = staticVar.idle;
        },
        deleteCompleteMedia: {
            reducer(state,action) {
                let media = state.media;
                state.media = media.filter( el => el.status !== staticVar.done && el.status !== staticVar.process);
            },
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createMedia.pending, (state,action) => {
                // const newItem = {...state.media.find(el => el.id === action.payload.id)};
            })
            .addCase(createMedia.fulfilled, (state,action) => {
                const newItem = {...state.media.find(el => el.id === action.payload.id)};
                if(Object.keys(newItem).length) {
                    newItem.video_url = action.payload.data.video_url;    
                    newItem.audio_url = action.payload.data.audio_url;    
                    newItem.duration_in_ms = action.payload.data.duration_in_ms;
                    newItem.image_url_original = action.payload.data.image_url_original;    
                    newItem.image_url_thumb = action.payload.data.image_url_thumb; 
                    newItem.startOnserver = false;
                    let message = '';   
                    if(!action.payload.updated) {
                        if(action.payload.data.media_type === staticVar.image.toUpperCase()) {
                            newItem.status = staticVar.done;
                            newItem.uploadStart = false;
                            message = 'upload successfully';
                        } else {
                            newItem.status = staticVar.upload;
                            newItem.presigned_url_key = action.payload.data.presigned_url_key;
                        }
                        if(action.payload.data.media_id !== action.payload.id) {
                            newItem.id = action.payload.data.media_id;
                            mediaFile[action.payload.data.media_id] = mediaFile[action.payload.id];
                            delete mediaFile[action.payload.id];
                        }
                        newItem.createOnServer = true;
                    } else {
                        newItem.tag = action.payload.data.tags;
                        newItem.name = action.payload.data.media_name;
                        newItem.shareMediaClip = action.payload.data.media_shared_type === 'MY_GYM_LOCATIONS';    
                        if(action.payload.data.media_type.toLowerCase() === staticVar.image) {
                            message = 'updated successfully';
                        } else {
                            if(action.payload.data.is_media_upload_from_panel_completed) {
                                if(CheckValue(action.payload.data.audio_url) || CheckValue(action.payload.data.video_url)) {
                                    newItem.status = staticVar.done;
                                    message = 'upload successfully';
                                } else {
                                    message = 'updated successfully';
                                    newItem.status = staticVar.process;
                                }
                                if(newItem.progress < 100) {
                                    newItem.progress = 100;
                                }
                            } else {
                                message = 'updated successfully';
                            }
                        }
                    }
                    const index = state.media.findIndex(el => el.id === action.payload.id);
                    if(!action.payload.firstTime && (newItem.status === staticVar.done || newItem.status === staticVar.process)) {
                        toasterSubscriber.sendToasterData({
                            showToaster: true,
                            showImage: true,
                            id: action.payload.id,
                            type: 'upload',
                            image: '',
                            message: newItem.name+' '+message
                        });

                    }
                    state.media[index] = newItem;
                }
            })
            .addCase(createMedia.rejected, (state,action) => {
                // ErrorUI(action.payload.err);
                const newItem = {...state.media.find(el => el.id === action.payload.id)};
                if(Object.keys(newItem).length) {
                    if(action.payload.updated) {
                        newItem.updated = false;
                    } else {
                        newItem.status = staticVar.error;
                    }
                    newItem.startOnserver = false;
                    const index = state.media.findIndex(el => el.id === action.payload.id);
                    state.media[index] = newItem;
                }
                state.status = staticVar.idle;
            })
    }
});

export const selectAllUploadMedia = (state) => state.uploadMedia;
export const { addMedia, updateMedia, mediaUploadDataChange, setError, updateMediaStatus, updateStatus, deleteCompleteMedia, resetMedia, deleteMedia, updateProgress, updateMediaStatusAndData } = uploadMediaSlice.actions;
export default uploadMediaSlice.reducer;